module.exports = __webpack_public_path__ + "img/pickleball-dark.d93e52dd.svg";